var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.0001H19C19.5304 22.0001 20.0391 21.7893 20.4142 21.4143C20.7893 21.0392 21 20.5305 21 20.0001V11.0001C21.0008 10.8685 20.9755 10.738 20.9258 10.6162C20.876 10.4943 20.8027 10.3835 20.71 10.2901L12.71 2.29006C12.5226 2.10381 12.2692 1.99927 12.005 1.99927C11.7408 1.99927 11.4874 2.10381 11.3 2.29006L3.3 10.2901C3.20551 10.3827 3.13034 10.4931 3.07885 10.615C3.02735 10.7369 3.00055 10.8678 3 11.0001V20.0001C3 20.5305 3.21071 21.0392 3.58579 21.4143C3.96086 21.7893 4.46957 22.0001 5 22.0001ZM10 20.0001V15.0001H14V20.0001H10ZM5 11.4101L12 4.41006L19 11.4101V20.0001H16V15.0001C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2108 14.5304 13.0001 14 13.0001H10C9.46957 13.0001 8.96086 13.2108 8.58579 13.5858C8.21071 13.9609 8 14.4696 8 15.0001V20.0001H5V11.4101Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.26f8a7aab986b6d507c707f086f1b91c.svg";
export { ForwardRef as ReactComponent };